import { SXStyleSheet } from '@/utils';
import { iconButtonClasses } from '@mui/material';

const style = SXStyleSheet.create({
  // Icons mit `currentColor` (Design-Paket 3) erben die Farbe des Knopfs.
  // MUIs IconButton-Default waere `action.active` (54 % Schwarz); die
  // Hausfarbe fuer Bedienelemente ist `text.primary`.
  icon: { color: 'text.primary' },
  outlined: {
    width: '40px',
    height: '40px',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    color: 'text.primary',
    [`&.${iconButtonClasses.disabled}`]: {
      opacity: 0.3,
    },
  },
  light: {
    color: 'primary.contrastText',
  },
  primary: {
    color: 'primary.main',
  },
});

export default style;
